
// SJ Wave eBook Claim Form Handler
// Submits email to Klaviyo and redirects to thank-you page

(function() {
  // Only run on the ebook claim page
  if (!window.location.pathname.includes('aquarium-ebook-claim')) return;

  var form = document.getElementById('sjwave-ebook-form');
  var emailInput = document.getElementById('sjwave-ebook-email');
  var submitBtn = document.getElementById('sjwave-ebook-submit');
  var errorMsg = document.getElementById('sjwave-ebook-error');

  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var email = emailInput ? emailInput.value.trim() : '';
    if (!email || !email.includes('@')) {
      if (errorMsg) {
        errorMsg.textContent = 'Please enter a valid email address.';
        errorMsg.style.display = 'block';
      }
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }
    if (errorMsg) errorMsg.style.display = 'none';

    // Klaviyo Client Subscriptions API
    var KLAVIYO_PUBLIC_KEY = 'W4fxCM';
    var LIST_ID = 'X84jpn';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: LIST_ID
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2023-02-22'
      },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      // 202 Accepted = success, 409 Conflict = already subscribed (also success)
      if (response.status === 202 || response.status === 409) {
        window.location.href = '/pages/ebook-claim-thank-you';
      } else {
        return response.json().then(function(data) {
          throw new Error(data.errors ? data.errors[0].detail : 'Subscription failed');
        });
      }
    })
    .catch(function(err) {
      console.error('Klaviyo error:', err);
      if (errorMsg) {
        errorMsg.textContent = 'Something went wrong. Please try again or contact info@sjwave.com';
        errorMsg.style.display = 'block';
      }
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'SUBMIT';
      }
    });
  });
})();
